
import axios from 'axios' //全局配置axios
import Qs from 'qs'
import config from './config'
axios.defaults.timeout = 30000;
console.log(process.env.NODE_ENV);
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? config.baseUrl.dev:config.baseUrl.pro;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
if (window.sessionStorage.getItem("Access-Token") != "") {
    axios.defaults.headers.common['Access-Token'] =
        window.sessionStorage.getItem("Access-Token");
}
// 请求的拦截器
axios.interceptors.request.use(function (config) {
    // 判断请求的类型
    // 如果是post请求就把默认参数拼到data里面
    // 如果是get请求就拼到params里面
    if (config.method === 'post') {
        if (config.headers['Content-Type'] != "multipart/form-data") {
            let data = Qs.parse(config.data)
            config.data = Qs.stringify({
                ...data
            })
        }
    } else if (config.method === 'get') {
        config.params = {
            ...config.params
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
})
axios.interceptors.response.use( //axios回调 拦截器  后期可以配置一下各种返回码的提示页面如404之类的
    response => {
        if (response.status === 200) {
            return response.data
        }
    },
    err => {
        return Promise.reject(err)
    }
)
export default axios
